/*
(required) value = String to be shown in label, children below can be used instead of value
(required) theme = "blue", "blue-dark", "blue-light", "gray" etc... NOTE: Need to extend the applyTheme() function
if trying to render a color that isn't in it
(optional) children = children can be used used instead of a value above
(optional) type = "location" - a location mark will be shown in the label
(optional) labelStyle = default "solid", "hollow"
(optional) twcss = "md:hidden uppercase"
(optional) link = "/"
(optional) fontStyles = "text-10" - styles applied directly to text

<BidLabel
    value="Seattle, WA"
    link="/"
    theme="blue-dark"
    type="location"
    labelStyle="hollow"
/>
*/
import Link from 'next/link'
import BidLocationIcon from '../BidLocationIcon/BidLocationIcon'

export default function BidLabel({
  type,
  value,
  labelStyle,
  theme,
  children,
  twcss,
  fontStyles,
  link,
  fullWidth,
}: any) {
  const applyTheme = (isHollow: any, isLocation?: any) => {
    let isHollowStyles = ''
    let defaultStyles = ''
    let locationIconStyles = ''
    const isGreen = ['Brand New', 'Appears New'].includes(value)
    if (isGreen) {
      isHollowStyles = 'border border-darkgreen text-darkgreen bg-white'
      defaultStyles = 'bg-darkgreen text-white'
      locationIconStyles = 'text-white'
    } else {
      switch (theme) {
        case 'blue':
          isHollowStyles = 'border border-bidfta-blue text-bidfta-blue bg-white'
          defaultStyles = 'bg-bidfta-blue text-white'
          locationIconStyles = 'text-white'
          break
        case 'blue-light':
          isHollowStyles =
            'border border-bidfta-blue-light text-bidfta-blue-light bg-white'
          defaultStyles = 'bg-bidfta-blue-light text-white'
          locationIconStyles = 'text-bidfta-blue-light'
          break
        case 'blue-dark':
          isHollowStyles =
            'border border-bidfta-blue-dark text-bidfta-blue-dark bg-white'
          defaultStyles = 'bg-bidfta-blue-dark text-white'
          locationIconStyles = 'text-bidfta-blue-dark'
          break
        case 'red':
          isHollowStyles = 'border border-bidfta-red text-bidfta-red bg-white'
          defaultStyles = 'bg-bidfta-red text-white'
          locationIconStyles = 'text-red'
          break
        default:
          break
      }
    }

    if (isLocation) {
      return locationIconStyles
    }
    return isHollow ? isHollowStyles : defaultStyles
  }

  return (
    <>
      {link ? (
        <Link href={link}>
          <div
            className={`px-3 py-2 flex items-center ${
              labelStyle === 'hollow' ? applyTheme(true) : applyTheme(false)
            } ${twcss || ''} ${fullWidth ? 'w-full h-auto' : 'w-max h-8'}`}
          >
            {type === 'location' && (
              <div className="mr-3 inline-block">
                <BidLocationIcon
                  fill={
                    labelStyle === 'hollow' ? applyTheme(true, true) : '#FFF'
                  }
                />
              </div>
            )}
            <span className="text-xs">{value || children}</span>
          </div>
        </Link>
      ) : (
        <div
          className={`px-3 py-1.5 flex items-center ${
            labelStyle === 'hollow' ? applyTheme(true) : applyTheme(false)
          } ${twcss || ''} ${fullWidth ? 'w-full h-auto' : 'w-max h-8'}`}
        >
          {type === 'location' && (
            <div className="mr-3 inline-block">
              <BidLocationIcon
                fill={labelStyle === 'hollow' ? applyTheme(true, true) : '#FFF'}
              />
            </div>
          )}
          <span className={`font-bold ${fontStyles || 'text-xs'}`}>
            {value || children}
          </span>
        </div>
      )}
    </>
  )
}
